<template>
  <div id="globe-rotate"></div>
</template>

<script>
  import echarts from 'echarts'
  import echartsGL from 'echarts-gl'
  export default {
    name: 'globe-rotate',
    mounted(){
      let myChart = echarts.init(document.getElementById('globe-rotate'))
      window.addEventListener('resize',()=>{myChart.resize()})
      myChart.setOption({
          baseOption: {
            backgroundColor: '#000',
            globe: {
                baseTexture: '/static/globe/data-1491837049070-rJZtl7Y6x.jpg',
                heightTexture: '/static/globe/data-1491889019097-rJQYikcpl.jpg',
                environment: '/static/globe/data-1499132777213-SyZdmO_4-.jpg',
                shading: 'lambert',
                globeRadius: 120,
                light: {
                  ambient: {
                    intensity: 1
                  },
                  main: {
                    intensity: 1
                  }
                },
                viewControl: {
                  rotateSensitivity: 0,
                  zoomSensitivity: 0,
                  autoRotate: true
                }
            },
            series: [{
                type: 'lines3D',
                coordinateSystem: 'globe',
                lineStyle: {
                  width: 1.5,
                  opacity: 0.8
                },
                data: []
            }]
          }
      });
    }
  }
</script>

<style lang="sass">
  #globe-rotate 
    width: 100%
    height: 100%
</style>


// WEBPACK FOOTER //
// src/components/GlobeRotate/GlobeRotate.vue